const state = {
  active: 0,
  items: []
}

export default state
